import React from 'react';
// @mui
import { Container, Grid, Typography } from '@mui/material';
// sections
import Voicemail from 'src/sections/voicemail/Voicemail';
// components
import Page from 'src/components/Page';
import PageHeader from 'src/components/PageHeader';
// hooks
import { useMatch } from 'react-location';
import useVoicemail from 'src/hooks/core-api/useVoicemail';
import useSettings from 'src/hooks/useSettings';
//
import moment from 'moment';
import { useSnackbar } from 'notistack';

const pageTitle = 'Voicemail Details';

const VoicemailSinglePage = () => {
  const { themeStretch } = useSettings();
  const {
    params: { voicemailId },
  } = useMatch();
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError, error } = useVoicemail(parseInt(voicemailId), {
    enabled: true,
  });

  if (isError) {
    const errorMessage = error instanceof Error ? error.message : 'An error occurred';
    enqueueSnackbar(errorMessage, {
      variant: 'error',
    });
  }

  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <PageHeader title={pageTitle} />
          </Grid>
          <Grid item xs={12} md={12}>
            {isLoading && (
              <Typography variant="h5" sx={{ textAlign: 'center' }}>
                Loading...
              </Typography>
            )}
            {data && (
              <>
                <Typography variant="h6" sx={{ mb: 3 }}>
                  {moment(data.created_on).format('dddd, MMMM Do YYYY, h:mm a')}
                </Typography>
                <Voicemail voicemail={data} />
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default VoicemailSinglePage;
